import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Configuration, ApiConfigOptions } from './config';

export interface ApiConfigOptionsStore {
  SHARED: ApiConfigOptions;
}

export const BASE_CONFIG_TOKEN = new InjectionToken('Base ApiConfigOptions');

@Injectable()
export class ApiConfigManager {
  private apiConfigs: Configuration[];

  constructor(@Optional() @Inject(BASE_CONFIG_TOKEN) private rawCfgStore: ApiConfigOptionsStore) {
    this.apiConfigs = [];
  }

  addApiConfig(name: keyof ApiConfigManager, config: Configuration): void {
    Object.defineProperty(this, name, { value: config });
    this.apiConfigs.push(config);
  }

  setAuth(accessToken: string): void {
    this.applyAll((cfg) => cfg.setOauth2Credentials(accessToken, true));
  }

  applyAll(fn: (cfg: Configuration) => void): void {
    for (const cfg of this.apiConfigs) {
      fn(cfg);
    }
  }

  withBase(cfg: ApiConfigOptions | undefined): ApiConfigOptions {
    // `cfg` is `ApiConfigOptions | undefined` because `getRawConfig` reads
    // augmentation-declared optional fields (each generated module adds its
    // config slot as `<name>?: ApiConfigOptions`). `Object.assign({}, …, undefined)`
    // is safe — falls through to the SHARED defaults when nothing is registered.
    return Object.assign({}, this.rawCfgStore.SHARED, cfg);
  }

  getRawConfig<K extends keyof ApiConfigOptionsStore>(apiName: K): ApiConfigOptionsStore[K] {
    return this.rawCfgStore[apiName];
  }
}
